import * as settingsWrapper from "@/services/edgeFunctionWrappers/settingsManagementWrapper";

export const INVOICE_CONFIG_KEY = "invoice_config";

export interface InvoiceConfig {
  companyName: string;
  companyAddress: string;
  companyTaxId: string;
  recipientEmail: string;
}

/** Valeurs historiques, conservées tant qu'aucune configuration n'a été saisie. */
export const LEGACY_INVOICE_CONFIG: InvoiceConfig = {
  companyName: "ST MM VISION",
  companyAddress: "018 Route de Gammarth La Marsa 2070",
  companyTaxId: "1782211Q/N/E/001",
  recipientEmail: "",
};

type StoredInvoiceConfig = Partial<{
  company_name: string;
  company_address: string;
  company_tax_id: string;
  recipient_email: string;
}>;

function fromStored(value: StoredInvoiceConfig | null | undefined): InvoiceConfig {
  return {
    companyName: value?.company_name?.trim() || LEGACY_INVOICE_CONFIG.companyName,
    companyAddress: value?.company_address?.trim() || LEGACY_INVOICE_CONFIG.companyAddress,
    companyTaxId: value?.company_tax_id?.trim() || LEGACY_INVOICE_CONFIG.companyTaxId,
    recipientEmail: value?.recipient_email?.trim() || "",
  };
}

export async function getInvoiceConfig(gymId: string): Promise<InvoiceConfig> {
  const setting = await settingsWrapper.getSettings(gymId, INVOICE_CONFIG_KEY);
  return fromStored(setting?.value as StoredInvoiceConfig | undefined);
}

export async function saveInvoiceConfig(gymId: string, config: InvoiceConfig): Promise<void> {
  await settingsWrapper.updateSettings(gymId, INVOICE_CONFIG_KEY, {
    company_name: config.companyName.trim(),
    company_address: config.companyAddress.trim(),
    company_tax_id: config.companyTaxId.trim(),
    recipient_email: config.recipientEmail.trim(),
  });
}
